import IconButton from "../../../../../components/IconButton";
import { IconCheck, IconEmail, IconEye, IconPencilRevert, IconTrash } from "../../../../../icons";
import useStoreGridCollaborator from "../store/useStore";
import { useHistory } from "react-router-dom";
import { remask } from "../../../../../libs/remask-mask";
import { IconClock } from "../../../../../icons/index";
import { useState } from "react";

export default function TBodyCollaborator() {
  const history = useHistory();
  const {
    setNeedModalDelete,
    setNeedModalPassword,
    setNeedModalPopUp,
    handleActiveClick,
    inactiveOrActive,
    collaboratorActivated,
    collaboratorsDeleted,
    page,
    selectSize,
    schedulesNexts,
  } = useStoreGridCollaborator();

  const [onClickUpdate, onClickDelete, onClickActive, onClickPassword, onClickHistory] = [
    handleUpdateClick,
    setNeedModalDelete,
    handleActiveClick,
    setNeedModalPassword,
    setNeedModalPopUp,
  ];
  const [needOptions, setNeedOptions] = useState<{ id: number; status: boolean }>();

  const listUsers = inactiveOrActive ? collaboratorsDeleted : collaboratorActivated;

  function handleUpdateClick(id: number) {
    history.push(`/collaborator/form/${id}`);
  }

  function onClickSchedule(id: number) {
    history.push(`/collaborator/form/schedule=${id}`);
  }

  function thisRender(index: number) {
    const finalRender = (page + 1) * selectSize;
    const startRender = page * selectSize;
    return index >= startRender && index < finalRender;
  }

  return listUsers?.map((row: any, index: any) => {
    const { id, name, email, CPF, phone, isDeleted, job_role, contract_type, isBilled, beginnig_at, end_date, birth_date } = row;
    const data = schedulesNexts?.map((schedule) => schedule?.userId);
    if (!thisRender(index)) return;
    return (
      <tr id={String(id)} key={index} className={`"collaboratorTableRow" ${index % 2 !== 0 && "rowGrey"}`}>
        <td>{name}</td>
        <td className="cpf-collaborator">{remask(CPF, ["999.999.999/99"])}</td>
        <td className="phone-collaborator">{remask(phone, ["(99) 9999-9999", "(99) 9 9999-9999"])}</td>
        <td>
          {job_role?.map((item: any) => {
            return <span className="m-right10">{item}</span>;
          })}
        </td>
        <td className="col-function contractType-td">{!contract_type || contract_type[0] === undefined ? "" : contract_type}</td>
        <td className="phone-collaborator">{isBilled ? "Sim" : "Não"}</td>
        <td className="beginnigAt-collaborator">{beginnig_at}</td>
        {inactiveOrActive && <td>{end_date?.length > 0 ? end_date : "--/--/----"}</td>}
        <td>{birth_date}</td>
        {needOptions?.status && needOptions?.id === id && <TableOptions data={data} id={id} isDeleted={isDeleted} email={email} />}
        {needOptions?.id !== id && (
          <td className="col-function">
            <IconButton className="icon center row-edit" onMouseEnter={() => setNeedOptions({ id, status: true })} icon={IconEye} />
          </td>
        )}
      </tr>
    );
  });

  function TableOptions({ data, id, isDeleted, email }) {
    return (
      <table onMouseLeave={() => setNeedOptions({ id: undefined, status: false })} className="table-options-collaborator">
        <thead>
          <tr>
            <th>Agendar</th>
            <th>Editar</th>
            <th>Ação</th>
            <th>Senha</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="col-function">
              <IconButton
                className={`icon center row-edit icon-collaborator ${data?.includes(id) && "row-trash"} `}
                icon={IconClock}
                onClick={() => onClickSchedule(id as number)}
              />
            </td>
            <td className="col-function">
              <IconButton
                className="icon center row-edit icon-collaborator"
                icon={IconPencilRevert}
                text=""
                onClick={() => onClickUpdate(id as number)}
              />
            </td>
            {!isDeleted ? (
              <td className="col-function invisible-530px">
                <IconButton
                  className="icon center row-trash icon-collaborator"
                  icon={IconTrash}
                  text=""
                  onClick={() => onClickDelete({ status: true, id: id })}
                />
              </td>
            ) : (
              <td className="col-function invisible-530px">
                <IconButton className="icon center row-active icon-collaborator" icon={IconCheck} text="" onClick={() => onClickActive(id)} />
              </td>
            )}
            <td className="col-function invisible-600px">
              <IconButton
                className="icon center row-password icon-collaborator"
                icon={IconEmail}
                text=""
                onClick={() => onClickPassword({ status: true, email: email })}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
